import App from './App.svelte';
import '../node_modules/materialize-css/dist/css/materialize.css'

const app = new App({
	target: document.body,
});

export default app;